import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { fuseAnimations } from '../../../../../core/animations'
import { AdministrationModel } from '../../../../models/administration.model'
import { DocumentsService } from '../../../../services/documents.service'
import { MatSort, MatTableDataSource, PageEvent, Sort } from '@angular/material'
import { ActivatedRoute, Router } from '@angular/router'
import { DocumentModel } from '../../../../models/document.model'
import { DocumentResponse } from '../../../../models/document-response'
import { Subscription } from 'rxjs'
import * as moment from 'moment'

@Component({
  selector: 'app-administration-documents',
  templateUrl: './administration-documents.component.html',
  styleUrls: ['./administration-documents.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationDocumentsComponent implements OnInit, OnDestroy {
  @Input() administration: AdministrationModel
  @ViewChild(MatSort) sort: MatSort

  isLoading = false
  administrationId: number
  documents: DocumentModel[]
  dataSource: any
  documentsResponse: DocumentResponse
  onDocumentsChange: Subscription

  displayedColumns = ['id', 'name', 'status', 'invoicetype', 'created_at']

  states = [
    { value: '', viewValue: 'STATUS' },
    { value: 'PROCESSED', viewValue: 'PROCESSED' },
    { value: 'IN_PROGRESS', viewValue: 'IN_PROGRESS' },
    { value: 'REJECTED', viewValue: 'REJECTED' },
  ]

  types = [
    { value: '', viewValue: 'TYPES' },
    { value: 'PURCHASE', viewValue: 'PURCHASE' },
    { value: 'SALES', viewValue: 'SALES' },
  ]

  constructor(private route: ActivatedRoute, private _router: Router, private _documentsService: DocumentsService) {
    this.administrationId = this.route.snapshot.params['administrationId']
  }

  ngOnInit() {
    this.onDocumentsChange = this._documentsService.browseByAdministration(this.administration.id).subscribe(data => {
      this.documents = data.rows
      this.dataSource = new MatTableDataSource(this.documents)
      this.documentsResponse = data
    })

    this.onDocumentsChange = this._documentsService.documentsChanged
      .filter(documentResponse => !!documentResponse)
      .subscribe((response: DocumentResponse) => {
        this.isLoading = false
        this.documentsResponse = response
        this.documents = response.rows
        this.dataSource = new MatTableDataSource(this.documents)
      })
  }

  public filterStatus(state: string) {
    this._documentsService.filter('status', state)
  }

  public filterType(type: string) {
    this._documentsService.filter('type', type)
  }

  ngOnDestroy(): void {
    this.onDocumentsChange.unsubscribe()
  }

  sortColumn(event?) {
    this._documentsService.mergeFilters({
      sort: event.active,
      direction: event.direction ? event.direction : 'ASC',
    })
  }

  /**
   *
   * @param {DocumentModel} document
   */
  readDocument(document: DocumentModel) {
    this._router.navigate(['documents/' + document.id])
  }

  pagination(event?: PageEvent) {
    const page = {
      page: event.pageIndex,
      limit: event.pageSize,
    }
    this._documentsService.mergeFilters(page)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-documents/administration-documents.component.ts